/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ArrowStyle {
	Arrow = 0,
	Filled = 1,
	Dotted = 2,
}
